import React, { PureComponent } from "react";
import { connect } from "react-redux";
import history from "../../../history/history";
import { Row, Col } from "antd";
import Preloader from "../../../CommonComponents/Preloader/Preloader";
import {
  getPrimaryAccount,
  getAccountData,
  updateSession,
  isGeminiUser
} from "../../../utils/sessionUtil";
import { fetchAccountSummaryData } from "./actions";
import { getInvestmentAccountApi, getSecNavigationAttrForCSR } from "./config";
import PendingAlerts from "./Component/PendingAlerts/PendingAlerts";
import { AccountCardComponent } from "./Component/CardComponent/CardComponent";
import "./AccountSummary.css";
import TableTabs from "./Component/Tabs/Tabs";
import BOTChart from "./Component/botchart/Botchart";
import moment from "moment";
import "moment-timezone";
import _ from "lodash";
import InvestmentAllocationTable from "./Component/investmentAllocationTable/InvestmentAllocationTable";
import DonutChart from "./Component/donutChart/DonutChart";
import QuickLinks from "./Component/quickLinks/QuickLinks";
import {
  isWalkthroughVisited,
  checkForFreezeFunctionality,
  initiateTracking,
  recordError,
  isAllShareAllPool
} from "../../../utils/commonUtil";
import WalkThroughComponent from "./Component/carousel/Carousel";
import {
  postCoachMarks,
  selectHeader,
  attributesForCSR,
  resetStepperIndex
} from "../../../actions/globalActions";
import { clearReducerForOpenAdditionalAccount } from "../../NPA/Pages/actions";
import CarouselComponent from "../../../CommonComponents/Carousel/CarouselComponent";
import PendingAlert from "../../MyAccounts/Components/PendingAlert/PendingAlert";
import TiffAlert from "./Component/PendingAlerts/TiffAlert";
import { AlertPopUpPrimary } from "../../NPA/Pages/Step1Setup/styles.js";
import { AccountOverviewWrapper, UnderLine } from "./style.js";
import loader from "../../../assets/icons/loader.gif";
import { TooltipContainerButton } from "../../../CommonComponents/Info/Tooltip/styles";
import BalanceCards from "../../../CommonComponents/BalanceCards/BalanceCards";
import BreadcrumbComponent from "../../../CommonComponents/Breadcrumb/Breadcrumb";
import {
  ContentProvider,
  ContentMessage,
  Types
} from "../../../CommonComponents/ContentMessages";
import { FixedWidth } from "../../../CommonComponents/commonStyles";
import { GeneralButton } from "../../../CommonComponents/Commons/commonComponents";
import { getAlert } from "../../NPA/Pages/Step1Setup/Components/UtilFunctions";
import { PropTypes } from "prop-types";
import { isReadOnlyWithExchangeRole } from "../../Investments/Pages/RecommendAnExchangeNew/util";
import { accountSummaryDerivedStates } from "./selectors";

let investmentPoolsTableData = "";
let investmentPoolsTableData_protfoliobuilder;

export class AccountSummary extends PureComponent {
  state = {
    balanceNewCompleteData: [],
    balanceNewData: [],
    chartNames: [],
    data: "",
    isTourOpen: true,
    modalAdditionalAcc: false,
    openAdditionalAlert: []
  };
  componentDidMount() {
    window.scrollTo(0, 0);
    let dafAccountId = getPrimaryAccount().userId;
    let partyId = getAccountData().partyId;
    if (window.top.frames.topBar){
      let topBarObj = window.top.frames.topBar
      topBarObj.postMessage(
        {
          message: "casegeneration",
          dafAccountId: dafAccountId,
          partyId: partyId
        },
        process.env.REACT_APP_GEMINI_CSR_URL
      );
    }
    this.props.fetchAccountSummaryData(getInvestmentAccountApi());
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.accountID !== nextProps.accountID) {
      let dafAccountId = getPrimaryAccount().userId;
      let partyId = getAccountData().partyId;
      if (window.top.frames.topBar){
        let topBarObj = window.top.frames.topBar;
        topBarObj.postMessage(
          {
            message: "casegeneration",
            dafAccountId: dafAccountId,
            partyId: partyId
          },
          process.env.REACT_APP_GEMINI_CSR_URL
        );
      }
      this.props.fetchAccountSummaryData(getInvestmentAccountApi());
      this.props.attributesForCSR(getSecNavigationAttrForCSR());
    }

    if (nextProps.isAccountSummaryLoading === false) {
      this.setbalancesCompleteData(nextProps);
    }
    if (nextProps.isAccountLoading === false) {
      this.filterData(nextProps);
    }

    if (nextProps.isAllAccountSummaryLoading === false) {
      this.setbalancesCompleteAllData(nextProps);
    }
  }
  setbalancesCompleteData(nextProps) {
    let oneYearData = _.orderBy(
      nextProps.accountSummaryBalance_data.balances,
      ["x"],
      ["asc"]
    );
    oneYearData.forEach(function(timestamp) {
      let zone = "America/New_York";

      let newDT = moment(timestamp.x).tz(zone);

      let znx = newDT.startOf("day").format();

      let newTimeStamp = moment(znx).unix() * 1000;
      timestamp.x = newTimeStamp;
    });
    this.setState({
      balanceNewCompleteData: oneYearData
    });

    setTimeout(function() {}.bind(this), 0);
  }
  setbalancesCompleteAllData(nextProps) {
    let fiveYearData = _.orderBy(
      nextProps.accountSummaryBalance_data_all.balances,
      ["x"],
      ["asc"]
    );

    fiveYearData.forEach(function(timestamp) {
      let zone = "America/New_York";

      let newDT = moment(timestamp.x).tz(zone);

      let znx = newDT.startOf("day").format();

      let newTimeStamp = moment(znx).unix() * 1000;
      timestamp.x = newTimeStamp;
    });

    this.setState({
      balanceNewData: fiveYearData
    });
  }

  filterData(nextProps) {
    investmentPoolsTableData_protfoliobuilder = undefined;
    let totalSum = 0;
    let pools = _.cloneDeep(nextProps.account_data.investmentPools);
    investmentPoolsTableData = _.groupBy(pools, function(pools) {
      return pools.type;
    });
    if (
      investmentPoolsTableData["BUILDING BLOCKS"] ||
      investmentPoolsTableData["SPECIFIC REGIONS"] ||
      investmentPoolsTableData["BALANCED FUNDS"]
    ) {
      investmentPoolsTableData_protfoliobuilder = [];
    }

    if (investmentPoolsTableData["BUILDING BLOCKS"]) {
      investmentPoolsTableData_protfoliobuilder.push(
        ...investmentPoolsTableData["BUILDING BLOCKS"]
      );
    }
    if (investmentPoolsTableData["SPECIFIC REGIONS"]) {
      investmentPoolsTableData_protfoliobuilder.push(
        ...investmentPoolsTableData["SPECIFIC REGIONS"]
      );
    }
    if (investmentPoolsTableData["BALANCED FUNDS"]) {
      investmentPoolsTableData_protfoliobuilder.push(
        ...investmentPoolsTableData["BALANCED FUNDS"]
      );
    }

    let pieChartData = [];
    let pieChartNames = [];

    if (nextProps.account_data.investmentPools.length === 0) {
      this.setState({
        errorMessage: ""
      });
    } else {
      _.map(nextProps.account_data.investmentPools, item => {
        if (typeof item.currentBalance === "number") {
          let chunks = [];
          chunks[0] = item.currentBalance;
          chunks[1] =
            (item.currentBalance / nextProps.account_data.currentBalance) * 100;
          chunks[2] = item.poolName;
          let Names = [];
          Names[0] = item.poolName;

          totalSum += parseFloat(chunks[1].toFixed(2));
          pieChartData.push(chunks);
          pieChartNames.push(Names);
        } else {
          this.setState({
            errorMessage: "Unable to render the allocation chart"
          });
        }
      });
      pieChartData
        .sort(function(a, b) {
          return a[1] - b[1];
        })
        .reverse();
      if (Math.abs(totalSum - 100)) {
        pieChartData[0][1] = pieChartData[0][1] + (100 - totalSum);
      }

      if (Math.round(totalSum) !== 100) {
        this.setState({
          errorMessage: "Unable to render the allocation chart"
        });
      } else {
        this.setState({
          data: pieChartData,
          chartNames: pieChartNames
        });
      }
    }
  }

  walkThrough = () => {
    document.body.style.overflow = "hidden";
    return (
      <div>
        {this.state.isTourOpen === true ? (
          <div className="overlay-positon overlay-background">
            <Row className="overlay-container">
              <Col>
                <WalkThroughComponent closeWalkThrough={this.closeTour} />
              </Col>
            </Row>
            <Row className="skip-overlay-container">
              <Col>
                <p onClick={this.closeTour}>
                  <u>SKIP TOUR</u>
                </p>
              </Col>
            </Row>
          </div>
        ) : (
          ""
        )}
      </div>
    );
  };
  closeTour = () => {
    try {
      document.body.style.overflow = "";
      this.setState({
        isTourOpen: false
      });
      updateSession({ visistedScreen: "Account Summary" });
      this.props.postCoachMarks({
        method: "PUT",
        url: `/donor-portal/api/party/${
          getAccountData().partyId
        }/saveCoachmarks`,
        data: { coachMark: "Account Summary" },
        page: "SessionTimeOut"
      });
    } catch (error) {
      recordError(error);
    }
  };

  showAdditionalAccountModal() {
    this.setState({ modalAdditionalAcc: true });
  }
  hideModal = () => {
    this.setState({ modalAdditionalAcc: false });
  };
  goToRoute(link, SelectName = "") {
    if (SelectName !== "") {
      this.props.selectHeader(SelectName);
    }
    if (link === "/open-an-additional-account/account-information/") {
      this.props.clearReducerForOpenAdditionalAccount();
      this.props.resetStepperState();
      initiateTracking(
        "openNewAccount",
        "Account Summary",
        "",
        "Open Another Account"
      );
    }
    history.push(link);
  }
  goToInviteParties(link) {
    try {
      this.props.selectHeader("Account Details");
      window.scrollTo(0, 0);
      history.push(link);
    } catch (error) {
      recordError(error);
    }
  }
  standingPendingAlert = () => {
    if (
      this.props.account_data &&
      this.props.account_data.authorization &&
      this.props.account_data.authorization.vanguardAccounts.length > 0
    ) {
      return this.props.account_data.authorization.vanguardAccounts.map(
        (accounts, index) => {
          let expDate = accounts.receivedDate + 157784630000;
          let expStartDate = expDate - 7776000000;
          let expEndDate = expDate + 2592000000;
          let newDate = Date.now() + -90 * 24 * 3600 * 1000;

          if (
            accounts.accountRegistration === "Private Foundation" ||
            accounts.accountRegistration === "Other"
          ) {
            if (Date.now() <= expDate && Date.now() >= expStartDate) {
              return (
                <PendingAlert TopMargin="0px" BottomMargin="20px">
                  <strong>Alert : </strong>The current Standing letter of
                  authorization on file for account number{" "}
                  {accounts.accountNumber} is about to expire. Please submit a
                  new &nbsp;
                  <a
                    href={
                      "https://www.vanguardcharitable.org/sites/default/files/upload/VOTLOAW_072011.pdf"
                    }
                    target="_blank"
                  >
                    <UnderLine>Standing letter of authorization form</UnderLine>
                  </a>
                  &nbsp; soon.
                </PendingAlert>
              );
            } else if (Date.now() > expDate && Date.now() <= expEndDate) {
              return (
                <PendingAlert TopMargin="0px" BottomMargin="20px">
                  <strong>Alert : </strong>The current Standing letter of
                  authorization on file for account number{" "}
                  {accounts.accountNumber} has expired. Please submit a new
                  &nbsp;
                  <a
                    href={
                      "https://www.vanguardcharitable.org/sites/default/files/upload/VOTLOAW_072011.pdf"
                    }
                    target="_blank"
                  >
                    <UnderLine>Standing letter of authorization form</UnderLine>
                  </a>
                  &nbsp; now.
                </PendingAlert>
              );
            }
          }
        }
      );
    }
  };

  checkDisabledCriteriaForCsr = () => {
    const { AdditionalAccountDetails } = this.props;
    return (
      _.indexOf(
        ["Trusted Advisor", "Designated Party"],
        AdditionalAccountDetails
      ) > -1
    );
  };

  //check no access level
  checkNoAccess = navBarData =>
    navBarData && navBarData.accessLevel === "No Access";

  // Check primary account donor and csruser
  checkPrimaryAccountDonor = () => {
    const { AdditionalAccountDetails } = this.props;
    return isGeminiUser() && AdditionalAccountDetails === "Donor";
  };

  // Check intrested party with no access
  checkIntrestedPartyWithNoAccess = () => {
    const { navBarData } = this.props;
    return (
      isGeminiUser() &&
      this.checkDisabledCriteriaForCsr() &&
      this.checkNoAccess(navBarData)
    );
  };

  // show tooltip message
  getTooltipMessage = () => {
    if (this.checkPrimaryAccountDonor())
      return "Donors without account access cannot view this page.";
    else if (this.checkIntrestedPartyWithNoAccess())
      return "Interested parties with no access to the account cannot view this page";
    else
      return "You are unable to invite interested parties on this account. If you believe this is an error, please contact us at 888-383-4483.";
  };

  accountStatus = text => {
    let primaryAccount = getPrimaryAccount();
    let freeze = checkForFreezeFunctionality();
    let accountStatus = { disabled: false, messages: "" };
    const { AdditionalAccountDetails, navBarData } = this.props;
    const isPrimaryAccountDonor = this.checkPrimaryAccountDonor();
    const isIntrestpartyWithNoAccess = this.checkIntrestedPartyWithNoAccess();
    let accountStatusWithDonor = {
      disabled: true,
      messages: "Donors without account access cannot view this page."
    };
    let accountStatusWithIntrestedPartyNoAccess = {
      disabled: true,
      messages:
        "Interested parties with no access to the account cannot view this page."
    };
    let isAllShareAllPoolStatus = isAllShareAllPool();
    if (text === "contribution") {
      if (freeze.includes("MAC")) {
        return {
          disabled: true,
          messages:
            "Transactions for this account are frozen. Contact us at 888-383-4483 or donorservice@vanguardcharitable.org."
        };
      } else if (primaryAccount.role.access === "Read Only") {
        return {
          disabled: true,
          messages:
            "You are unable to recommend contributions on this account. If you believe this is an error, please contact us at 888-383-4483."
        };
      } else if (isPrimaryAccountDonor) {
        return accountStatusWithDonor;
      } else if (isIntrestpartyWithNoAccess) {
        return accountStatusWithIntrestedPartyNoAccess;
      }
      return accountStatus;
    }
    if (text === "grant") {
      if (freeze.includes("RAG")) {
        return {
          disabled: true,
          messages:
            "Transactions for this account are frozen. Contact us at 888-383-4483 or donorservice@vanguardcharitable.org."
        };
      }
      if (this.props.account_data.availableBalance === 0) {
        return {
          disabled: true,
          messages:
            "This account has $0.00 available balance. Grant Transaction cannot continue."
        };
      }else if (isAllShareAllPoolStatus) {
        return {
          disabled: true,
          messages:
            "A grant has been recommended to close the account. Additional grant transactions cannot be submitted."
        };
      } else if (primaryAccount.role.access === "Read Only") {
        return {
          disabled: true,
          messages:
            "You are unable to recommend grants on this account. If you believe this is an error, please contact us at 888-383-4483."
        };
      } else if (isPrimaryAccountDonor) {
        return accountStatusWithDonor;
      } else if (isIntrestpartyWithNoAccess) {
        return accountStatusWithIntrestedPartyNoAccess;
      }
      return accountStatus;
    }
    if (text === "exchange") {
      if (freeze.includes("RAE")) {
        return {
          disabled: true,
          messages:
            "Transactions for this account are frozen. Contact us at 888-383-4483 or donorservice@vanguardcharitable.org."
        };
      }
      if (this.props.account_data.availableBalance === 0) {
        return {
          disabled: true,
          messages:
            "This account has $0.00 available balance. Exchange Transaction cannot continue."
        };
      } else if (isAllShareAllPoolStatus) {
        return {
          disabled: true,
          messages:
            "A grant has been recommended to close the account. Exchanges cannot be submitted."
        };
      }else if (primaryAccount.role.access === "Read Only" && !isReadOnlyWithExchangeRole()) {
        return {
          disabled: true,
          messages:
            "You are unable to recommend exchanges on this account. If you believe this is an error, please contact us at 888-383-4483."
        };
      } else if (isPrimaryAccountDonor) {
        return accountStatusWithDonor;
      } else if (isIntrestpartyWithNoAccess) {
        return accountStatusWithIntrestedPartyNoAccess;
      }
      return accountStatus;
    }
  };

  navigateToMakeContribution = () => {
    try {
      this.props.selectHeader("Contribution Activity");
      history.push("/contributions/make-a-contribution");
    } catch (error) {
      recordError(error);
    }
  };
  navigateToRecomendGrant = () => {
    try {
      this.props.selectHeader("Grant Activity");
      history.push("/grants/recommend");
    } catch (error) {
      recordError(error);
    }
  };
  navigateToExchange = () => {
    try {
      this.props.selectHeader("Exchange Activity");
      history.push("/investments/recommend-an-exchange/NEW/from");
    } catch (error) {
      recordError(error);
    }
  };

  goFromCardsToPage = (e, pathName, query, selectedHeader) => {
    e.preventDefault();
    selectedHeader && this.props.selectHeader(selectedHeader);
    if (query) {
      this.props.history.push(pathName + query);
    } else {
      this.props.history.push(pathName);
    }
  };

  firstNameAsTitle = () => {
    const {account_data} = this.props
    if (account_data && account_data.personNameDetails && account_data.personNameDetails.firstName){
      return account_data.personNameDetails.firstName
    }
  }

  render() {
    const BalanceCardsConfiguration = [
      {
        heading: "Current Balance",
        balance: this.props.account_data.currentBalance,
        text:
          "Balance in your donor-advised fund after the previous day's trading cycle is complete",
        url: "/contributions",
        comingSoon: true
      },
      {
        heading: "Available Balance",
        balance: this.props.account_data.availableBalance,
        text:
          "Your current balance, minus any pending grants, pending exchanges, or assets invested in TIFF",
        url: "/my-account/transaction-summary",
        buttonName: "VIEW TRANSACTION SUMMARY",
        comingSoon: false,
        pageName: "Transaction Summary"
      }
    ];
    this.breadcrumbRoutes = () => {
      return [
        {
          routeName: "Home",
          path: "/"
        },
        {
          routeName: "Account Summary",
          path: "/"
        }
      ];
    };
    let primaryAccount = getPrimaryAccount();

    let grantStatus = this.accountStatus("grant");
    let exchangeStatus = this.accountStatus("exchange");
    let contributionStatus = this.accountStatus("contribution");

    const { openAdditionalAlert } = this.state;
    const { alertOOA } = this.props;
    
    if (alertOOA.length && !openAdditionalAlert.length) {
      this.setState({
        openAdditionalAlert: getAlert(alertOOA, "Alert")
      });
    }

    if (this.props.isAccountLoading) {
      return (
        <div>
          <div className="loadingContainer">
            <div />
            <Preloader />
          </div>
        </div>
      );
    } else {
      return (
        <div className="accountSummary">
          {this.state.modalAdditionalAcc && (
            <>
              <AlertPopUpPrimary
                title={
                  (openAdditionalAlert.length &&
                    openAdditionalAlert[0].field_header) ||
                  "Alert"
                }
                visible={this.state.modalAdditionalAcc}
                width="580px"
                onOk={this.goToRoute.bind(
                  this,
                  "/open-an-additional-account/account-information/"
                )}
                onCancel={this.hideModal}
                cancelText={
                  (openAdditionalAlert.length &&
                    openAdditionalAlert[0].field_alert_button2_text) ||
                  "close"
                }
                okText={
                  (openAdditionalAlert.length &&
                    openAdditionalAlert[0].field_alert_button1_text) ||
                  "CONTINUE"
                }
              >
                {(openAdditionalAlert.length && (
                  <span
                    dangerouslySetInnerHTML={{
                      __html: openAdditionalAlert[0].field_description
                    }}
                  />
                )) || (
                  <>
                    Your existing account information will pre-fill the
                    following profile screen. Any changes made to your personal
                    information will overwrite your profile throughout the
                    website.
                    <br />
                    Although you must be an account advisor on any account you
                    open, you will have the option to add a second advisor.
                  </>
                )}
              </AlertPopUpPrimary>
            </>
          )}
          <ContentProvider
            types={[Types.PAGE_TITLE_DESCRIPTION]}
            pages={["Account Summary"]}
          >
            <div className="account-summary">
              <div className="account-summary">
                {isWalkthroughVisited("Account Summary") === true ? (
                  <div>{this.walkThrough()}</div>
                ) : (
                  ""
                )}
                <FixedWidth>
                  <Row className="page-header">
                    <BreadcrumbComponent
                      breadcrumbRoutes={this.breadcrumbRoutes()}
                    />
                    <AccountOverviewWrapper>
                      <h1 className="accountTitle">
                        {"Hello,"}{" "}{this.firstNameAsTitle()}
                      </h1>
                      <h2>
                        {primaryAccount.accountName} {<span>-</span>}
                        {primaryAccount.accountNumber}
                      </h2>
                      {this.props.account_data.accessKey ? (
                        <div>
                          <h3>
                            {"Access Key"} {<span>-</span>}{" "}
                            {this.props.account_data.accessKey}
                          </h3>
                          <h3 className="AccesKeyMsg">
                            {
                              "This Access Key will expire four hours from the time it is generated"
                            }
                          </h3>
                        </div>
                      ) : (
                        <div />
                      )}

                      {this.props.account_data.accountType === "Select" ? (
                        <h4>
                          {"Account Class - "}
                          {this.props.account_data.accountType}
                        </h4>
                      ) : (
                        <div />
                      )}
                    </AccountOverviewWrapper>
                  </Row>
                  {this.props.isContributionLoading === true &&
                  this.props.isAccountSummaryLoading === true ? (
                    <div />
                  ) : (
                    <Row>
                      <PendingAlerts
                        Loading={this.props.isContributionLoading}
                        MaintainceAlertLoading={this.props.isAccountLoading}
                        contribution={this.props.contribution}
                        account_data={this.props.account_data}
                        additional_accnt_dets={
                          this.props.AdditionalAccountDetails
                        }
                      />
                      {this.standingPendingAlert()}
                      <TiffAlert
                        Loading={this.props.isAccountSummaryLoading}
                        account_data={this.props.account_data}
                      />
                    </Row>
                  )}
                </FixedWidth>
              </div>
              <div className="bg-gray-color-container">
                <FixedWidth>
                  <Row>
                    <Col md={{ span: 24 }}>
                      <Row className="current-balance-container">
                        <Col md={{ span: 8 }} xs={{ span: 24 }}>
                          <BalanceCards
                            grantsDashboard={true}
                            config={BalanceCardsConfiguration}
                            clicked={(e, pathName, query, selectedHeader) =>
                              this.goFromCardsToPage(
                                e,
                                pathName,
                                query,
                                selectedHeader
                              )
                            }
                          />
                        </Col>

                        <Col md={{ span: 16 }} xs={{ span: 24 }}>
                          <TableTabs />
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                  <Row className="quick-links-container">
                    <Col
                      className="Button-tooltip"
                      md={{ span: 12 }}
                      lg={{ span: 6 }}
                      onClick={
                        contributionStatus.disabled
                          ? null
                          : () => this.navigateToMakeContribution()
                      }
                    >
                      <TooltipContainerButton
                        title={contributionStatus.messages}
                        placement="top"
                      >
                        <GeneralButton
                          disabled={contributionStatus.disabled}
                          text="Contribute"
                          type="primary"
                          width={"100%"}
                          data-test="contribution-click-btn"
                          mobWidth="100%"
                        >
                          {" "}
                        </GeneralButton>
                      </TooltipContainerButton>
                    </Col>

                    <Col
                      className="Button-tooltip"
                      md={{ span: 12 }}
                      lg={{ span: 6 }}
                      onClick={
                        grantStatus.disabled
                          ? null
                          : () => this.navigateToRecomendGrant()
                      }
                    >
                      <TooltipContainerButton
                        title={grantStatus.messages}
                        placement="top"
                      >
                        {" "}
                        <GeneralButton
                          disabled={grantStatus.disabled}
                          text="Grant"
                          type="primary"
                          width={"100%"}
                          data-test="grant-click-btn"
                          mobWidth="100%"
                        >
                          {" "}
                        </GeneralButton>
                      </TooltipContainerButton>
                    </Col>

                    <Col
                      className="Button-tooltip"
                      md={{ span: 12 }}
                      lg={{ span: 6 }}
                      onClick={
                        exchangeStatus.disabled
                          ? null
                          : () => this.navigateToExchange()
                      }
                    >
                      <TooltipContainerButton
                        title={exchangeStatus.messages}
                        placement="top"
                      >
                        {" "}
                        <GeneralButton
                          disabled={exchangeStatus.disabled}
                          text="Exchange"
                          type="primary"
                          width={"100%"}
                          data-test="exchange-click-btn"
                          mobWidth="100%"
                        >
                          {" "}
                        </GeneralButton>
                      </TooltipContainerButton>
                    </Col>

                    <Col
                      className="quicklinks-dropdown dropdown"
                      md={{ span: 12 }}
                      lg={{ span: 6 }}
                    >
                      <AccountCardComponent>
                        <QuickLinks />
                      </AccountCardComponent>
                    </Col>
                  </Row>
                  <Row>
                    <Col md={{ span: 24 }}>
                      <CarouselComponent isMargin />
                    </Col>
                  </Row>
                </FixedWidth>
              </div>
              <div className="main-max-width-container">
                <div className="graph-container">
                  <Row>
                    <b>Account Activity</b>
                    <h2>Balance over time</h2>
                    <h3 className="desktop-content">
                      Keeping up with your philanthropic impact has never been
                      easier. Hover your cursor over the timeline to reveal
                      account balances.
                    </h3>
                    <h3 className="mobile-content">
                      Keeping up with your philanthropic impact has never been
                      easier. Hover your cursor over the timeline to reveal
                      account balances.
                    </h3>
                  </Row>
                  <Row>
                    {this.props.isAccountSummaryLoading === true ? (
                      <div>
                        <div className="noDataPlacement chart-no-data">
                          <div className="loader-position">
                            <div>
                              <img
                                alt="Loader"
                                src={loader}
                                className="mr-icon"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    ) : this.state.balanceNewCompleteData.length === 0 ? (
                      <div>
                        <div className="noDataPlacement chart-no-data">
                          <div>No data found for charts.</div>
                        </div>
                      </div>
                    ) : (
                      <BOTChart
                        data={this.state.balanceNewCompleteData}
                        dataAll={this.state.balanceNewData}
                        botStatusText={this.props.botStatusText}
                      />
                    )}
                  </Row>
                </div>
              </div>
              <div
                className={
                  this.props.isAccountLoading === false &&
                  this.props.account_data.currentBalance === 0
                    ? "hide"
                    : "bg-gray-color-container"
                }
              >
                <div className="main-max-width-container donut-chart-container">
                  <Row>
                    <Col className="donut-chart-header">
                      <div className="today-date">
                        {moment.tz(new Date(), "America/New_York").format("LL")}
                      </div>
                      <h2> Investment Allocation</h2>
                    </Col>
                  </Row>
                  <Row>
                    <Col
                      className="donut-chart"
                      md={{ span: 24 }}
                      lg={{ span: 10 }}
                    >
                      <DonutChart
                        data={this.state.data}
                        isAccountSummaryLoading={this.props.isAccountLoading}
                        chartNames={this.state.chartNames}
                        balance={
                          "$" +
                          Number(
                            this.props.account_data.currentBalance
                          ).toLocaleString(undefined, {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2
                          })
                        }
                        errorMessage={this.state.errorMessage}
                      />
                    </Col>
                    <Col
                      className="investment-allocation-table"
                      md={{ span: 24 }}
                      lg={{ span: 14 }}
                    >
                      <div className="overflowfix">
                        <div
                          className={
                            investmentPoolsTableData_protfoliobuilder ===
                            undefined
                              ? "hide"
                              : "show"
                          }
                        >
                          <h2>Portfolio Builders</h2>
                          <InvestmentAllocationTable
                            data={investmentPoolsTableData_protfoliobuilder}
                          />
                        </div>
                        <div
                          className={
                            investmentPoolsTableData["PORTFOLIO SOLUTIONS"] ===
                            undefined
                              ? "hide"
                              : "show"
                          }
                        >
                          {" "}
                          <h2>Portfolio Solutions</h2>
                          <InvestmentAllocationTable
                            data={
                              investmentPoolsTableData["PORTFOLIO SOLUTIONS"]
                            }
                          />
                        </div>
                        <div
                          className={
                            investmentPoolsTableData[
                              "VALUES DRIVEN INVESTMENTS"
                            ] === undefined
                              ? "hide"
                              : "show"
                          }
                        >
                          <h2>Values-driven Investments</h2>
                          <InvestmentAllocationTable
                            data={
                              investmentPoolsTableData[
                                "VALUES DRIVEN INVESTMENTS"
                              ]
                            }
                            isAccountSummaryLoading={
                              this.props.isAccountSummaryLoading
                            }
                          />
                        </div>
                      </div>
                    </Col>
                  </Row>
                </div>
              </div>

              <div className="footer-quick-links-container">
                <Row className="main-max-width-container">
                  <Col className="Button-tooltip" md={{ span: 12 }}>
                    {this.checkPrimaryAccountDonor() ||
                    this.checkIntrestedPartyWithNoAccess() ? (
                      <TooltipContainerButton
                        title={this.getTooltipMessage()}
                        placement="top"
                      >
                        {" "}
                        <GeneralButton
                          disabled={true}
                          text="Open Another Account"
                          type="primary"
                          width={"100%"}
                          mobWidth="100%"
                          mobWidth="100%"
                        >
                          {" "}
                        </GeneralButton>
                      </TooltipContainerButton>
                    ) : (
                      <span
                        className="tool-tip"
                        tabindex="0"
                        title=""
                        onClick={this.showAdditionalAccountModal.bind(this)}
                      >
                        {" "}
                        <GeneralButton
                          disabled={false}
                          text="Open Another Account"
                          type="primary"
                          width={"100%"}
                          mobWidth="100%"
                        >
                          {" "}
                        </GeneralButton>
                      </span>
                    )}
                  </Col>
                  <Col className="Button-tooltip" md={{ span: 12 }}>
                    {primaryAccount.role.access === "Read Only" ||
                    this.props.AdditionalAccountDetails !==
                      "Account Advisor" ? (
                      <TooltipContainerButton
                        title={this.getTooltipMessage()}
                        placement="top"
                      >
                        {" "}
                        <GeneralButton
                          disabled={true}
                          text=" Invite An Interested Party"
                          type="primary"
                          width={"100%"}
                          mobWidth="100%"
                        >
                          {" "}
                        </GeneralButton>
                      </TooltipContainerButton>
                    ) : (
                      <span
                        className="tool-tip"
                        tabindex="0"
                        title=""
                        onClick={this.showAdditionalAccountModal.bind(this)}
                      >
                        {" "}
                        <span
                          onClick={this.goToInviteParties.bind(
                            this,
                            "/my-account/invite-interested-parties"
                          )}
                        >
                          <GeneralButton
                            disabled={false}
                            text="Invite An Interested Party"
                            type="primary"
                            width={"100%"}
                            mobWidth="100%"
                          >
                            {" "}
                          </GeneralButton>
                        </span>
                      </span>
                    )}
                  </Col>
                </Row>
              </div>
            </div>
          </ContentProvider>
        </div>
      );
    }
  }
}
AccountSummary.propTypes = {
  isInvestmentLoading: PropTypes.bool,
  isGrantLoading: PropTypes.bool,
  myAccount_data: PropTypes.any,
  investmentData: PropTypes.array,
  grant_data: PropTypes.array,
  contribution: PropTypes.array,
  isAccountSummaryLoading: PropTypes.bool,
  accountSummaryBalance_data: PropTypes.array,
  isAllAccountSummaryLoading: PropTypes.bool,
  otherTransaction_data: PropTypes.array,
  isOtherTransactionLoading: PropTypes.bool,
  account_data: PropTypes.object,
  alertOOA: PropTypes.array,
  botStatusText: PropTypes.string
};

export const mapStateToProps = state => {
  return {
    alertOOA: state.getIn(["npaFormReducer", "alerts"]),
    ...accountSummaryDerivedStates(state.toJS())
  };
};

export const mapDispatchToProps = dispatch => {
  return {
    fetchAccountSummaryData: data => dispatch(fetchAccountSummaryData(data)),
    postCoachMarks: data => dispatch(postCoachMarks(data)),
    selectHeader: data => dispatch(selectHeader(data)),
    attributesForCSR: data => dispatch(attributesForCSR(data)),
    clearReducerForOpenAdditionalAccount: () =>
      dispatch(clearReducerForOpenAdditionalAccount()),
    resetStepperState: () => dispatch(resetStepperIndex())
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps,
  null,
  { pure: true }
)(AccountSummary);
